export default "__VITE_ASSET__59102ea2__"